export default __webpack_public_path__ + "static/media/12.blur.22c695ba.jpeg";